var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGbp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.481 4.694A11.94 11.94 0 0 0 .414 8.87h6.243L2.481 4.694zM23.587 8.87a11.96 11.96 0 0 0-2.067-4.175L17.344 8.87h6.243zM.414 15.131a11.96 11.96 0 0 0 2.067 4.175l4.175-4.175H.414zm18.892-12.65C18.08 1.538 16.666.827 15.131.413v6.243l4.176-4.175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.695 21.519a11.95 11.95 0 0 0 4.175 2.067v-6.243l-4.175 4.175zM8.87.413C7.334.827 5.921 1.538 4.695 2.481L8.87 6.656V.413zm6.261 23.174a11.96 11.96 0 0 0 4.175-2.067l-4.175-4.175v6.243zm2.213-8.456l4.175 4.175a11.95 11.95 0 0 0 2.067-4.175h-6.243z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.898 10.435H13.565V.102A12.12 12.12 0 0 0 12 0c-.531 0-1.053.035-1.565.102v10.333H.102A12.12 12.12 0 0 0 0 12c0 .531.035 1.053.102 1.565h10.333v10.333A12.12 12.12 0 0 0 12 24a12.1 12.1 0 0 0 1.565-.102V13.565h10.333a12.12 12.12 0 0 0 0-3.131zm-8.768 4.696l5.355 5.355.705-.77-4.584-4.584H15.13zm-6.26 0h0l-5.355 5.355.77.705 4.584-4.584v-1.476zM8.869 8.87h0L3.515 3.515l-.705.77L7.394 8.87H8.87zm6.261 0l5.355-5.355-.77-.705-4.584 4.585V8.87z",
    fill: "#d80027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/gbp.2bcca8ea1aeb66fb9c7cc860281f4422.svg";
export { ForwardRef as ReactComponent };